import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { Hotspot } from "./Hotspot";

export function StorageTank({ sim, selected, onSelect, copy }) {
  const fill = useRef();
  useFrame(() => {
    const level = Math.max(0.005, sim.current.energy / 100);
    fill.current.scale.y = level;
    fill.current.position.y = 0.5 + 1.4 * level;
  });
  return (
    <group position={[1, 0, 0.3]} onClick={e => { e.stopPropagation(); onSelect("storage"); }}>
      <mesh position={[0, 0.15, 0]}><cylinderGeometry args={[1.15, 1.15, 0.3, 32]} /><meshStandardMaterial color="#666e70" metalness={0.6} roughness={0.4} /></mesh>
      <mesh ref={fill}><cylinderGeometry args={[0.78, 0.78, 2.8, 32]} /><meshStandardMaterial color="#ff5a3c" emissive="#ff3b30" emissiveIntensity={0.35} roughness={0.4} /></mesh>
      <mesh position={[0, 1.9, 0]}><cylinderGeometry args={[0.94, 0.94, 3.1, 32]} /><meshPhysicalMaterial color={selected === "storage" ? "#baffda" : "#d3e4ea"} transparent opacity={0.22} roughness={0.2} metalness={0.1} depthWrite={false} /></mesh>
      {[0.42, 1.05, 2.75, 3.42].map(y => <mesh key={y} position={[0, y, 0]} rotation={[Math.PI / 2, 0, 0]}><torusGeometry args={[0.96, 0.055, 8, 48]} /><meshStandardMaterial color={selected === "storage" ? "#00ff88" : "#bbc6ca"} metalness={0.8} roughness={0.3} /></mesh>)}
      {[0.37, 3.47].map(y => <mesh key={y} position={[0, y, 0]}><cylinderGeometry args={[0.95, 0.95, 0.16, 32]} /><meshStandardMaterial color="#aeb8be" metalness={0.8} roughness={0.3} /></mesh>)}
      <Hotspot part="storage" position={[0, 4.1, 0]} {...{ selected, onSelect, copy }} />
    </group>
  );
}

export function IndustrialPlant({ sim, selected, onSelect, copy, running }) {
  const rotor = useRef();
  const lamp = useRef();
  useFrame(() => {
    const active = sim.current.output > 0.005;
    rotor.current.rotation.z = active ? sim.current.time * 2 : rotor.current.rotation.z;
    lamp.current.color.set(active && running ? "#00ff88" : "#657176");
    lamp.current.emissiveIntensity = active && running ? 1 : 0;
  });
  return (
    <group position={[5.6, 0, 0]} onClick={e => { e.stopPropagation(); onSelect("industry"); }}>
      <mesh position={[0, 0.15, 0]}><boxGeometry args={[3.6, 0.3, 2.7]} /><meshStandardMaterial color="#5e666a" /></mesh>
      <mesh position={[0.2, 1.35, -0.4]}><boxGeometry args={[3.1, 2.4, 1.5]} /><meshStandardMaterial color="#8f9da5" metalness={0.65} roughness={0.35} emissive="#00ff88" emissiveIntensity={selected === "industry" ? 0.2 : 0} /></mesh>
      <mesh position={[0.2, 2.6, -0.4]} rotation={[0, 0, 0.1]}><boxGeometry args={[3.4, 0.15, 1.8]} /><meshStandardMaterial color="#b8c5cb" metalness={0.6} roughness={0.4} /></mesh>
      {[-0.7, 0.1, 0.9].map(x => <mesh key={x} position={[x, 1.8, 0.37]}><boxGeometry args={[0.48, 0.5, 0.04]} /><meshStandardMaterial color="#193e44" emissive="#2b7180" emissiveIntensity={0.25} /></mesh>)}
      <mesh position={[-0.65, 0.95, 1]}><boxGeometry args={[1.65, 1.05, 0.65]} /><meshStandardMaterial color="#3a454a" metalness={0.65} roughness={0.3} /></mesh>
      {Array.from({ length: 8 }, (_, i) => <mesh key={i} position={[-1.3 + i * 0.18, 0.95, 1.36]}><boxGeometry args={[0.07, 0.9, 0.08]} /><meshStandardMaterial color={i % 2 ? "#4799ff" : "#ff675d"} /></mesh>)}
      <group ref={rotor} position={[1.15, 0.9, 0.5]}>
        <mesh><torusGeometry args={[0.4, 0.06, 8, 24]} /><meshStandardMaterial color="#bcc8cd" /></mesh>
        {[0, Math.PI / 2].map(a => <mesh key={a} rotation={[0, 0, a]}><boxGeometry args={[0.7, 0.1, 0.08]} /><meshStandardMaterial color="#aebec8" /></mesh>)}
      </group>
      <mesh position={[1.4, 2.15, 0.4]}><sphereGeometry args={[0.1, 12, 12]} /><meshStandardMaterial ref={lamp} emissive="#00ff88" /></mesh>
      <Hotspot part="industry" position={[0, 3.25, 0]} {...{ selected, onSelect, copy }} />
    </group>
  );
}